import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class CountryService {
    constructor(private httpClient: HttpClient) {}

    async getForUI() {
        const countries = await this.httpClient.get<{ name: string; code: string }[]>('./assets/countries.json').toPromise();
        const countriesUI = [
            { code: 'BE', name: 'Belgium' },
            { code: 'NL', name: 'Netherlands' },
            { code: 'LU', name: 'Luxembourg' },
            { code: 'DE', name: 'Germany' },
            { code: 'FR', name: 'France' },
            { code: 'GB', name: 'United Kingdom' },
            { code: 'CA', name: 'Canada' },
            { code: null, name: '--' }
        ].concat(countries);
        return countriesUI;
    }
}
